const name = 'circle-1';

const contents = '<path fill="#FFF" d="M41.15 55h-20.3v-4.806h7.374V36.771l.497-3.728h-.497l-1.657 1.74-3.314 1.657-2.403-4.64 9.031-5.054h3.978v23.448h7.291z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '1',
};

export default icon;
